/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BlogManagerEditArticleRequest = {
    id: number;
    image_id: number;
    title?: string;
    title_en?: string;
    title_cn?: string;
    context?: string;
    context_en?: string;
    context_cn?: string;
    post_date?: string;
    open_status?: BlogManagerEditArticleRequest.open_status;
    release_setting?: BlogManagerEditArticleRequest.release_setting;
    tag_ids?: string;
};

export namespace BlogManagerEditArticleRequest {

    export enum open_status {
        EDIT = 'edit',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum release_setting {
        NOW = 'now',
        DATE = 'date',
    }


}

